import { CSSObject } from '@chakra-ui/react';

export const Indicator = (): CSSObject => ({
  ml: '6px',

  _first: { ml: '1' },
});
